import { Range, Editor } from 'slate';
import { isRangeWithinVoid } from '../../queries/isRangeWithinVoid.mjs';

// To-do: Remove this once this issue is fixed in Slate
// https://github.com/ianstormtaylor/slate/issues/3336
function unhangRange(editor, range) {
  if (isRangeWithinVoid(editor, range)) {
    return range;
  }
  let {
    anchor,
    focus
  } = range;
  const isRangeBackward = Range.isBackward(range);
  const lookup = {
    anchor: isRangeBackward ? Editor.isStart : Editor.isEnd,
    focus: isRangeBackward ? Editor.isEnd : Editor.isStart
  };
  const anchorIsHanging = lookup.anchor(editor, anchor, anchor.path);
  const focusIsHanging = lookup.focus(editor, focus, focus.path);
  if (anchorIsHanging) {
    const after = Editor.after(editor, anchor);
    anchor = after != null ? after : anchor;
  }
  if (focusIsHanging) {
    const before = Editor.before(editor, focus);
    focus = before != null ? before : focus;
  }
  return {
    anchor,
    focus
  };
}

export { unhangRange };
